export function LogOutIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M15.071 7.757a1 1 0 10-1.414 1.415L15.485 11h-6.07a1 1 0 100 2h6.07l-1.828 1.828a1 1 0 101.414 1.415l3.182-3.182a1.5 1.5 0 000-2.122l-3.182-3.182z"
      ></path>
      <path
        fill="currentColor"
        d="M19.995 16.51c.473.27.639.873.32 1.313a10.088 10.088 0 01-4.47 3.465 10.2 10.2 0 01-6.612.3 10.1 10.1 0 01-5.38-3.817 9.927 9.927 0 01-1.84-6.294 9.946 9.946 0 012.494-6.07 10.127 10.127 0 015.754-3.24 10.193 10.193 0 016.545.983 10.056 10.056 0 014.08 3.91c.27.47.04 1.05-.458 1.27-.5.22-1.079-.005-1.36-.469a8.091 8.091 0 00-3.183-2.978 8.198 8.198 0 00-5.263-.79 8.145 8.145 0 00-4.628 2.604 7.999 7.999 0 00-2.005 4.882 7.984 7.984 0 001.478 5.063 8.122 8.122 0 004.328 3.07 8.203 8.203 0 005.318-.242 8.115 8.115 0 003.48-2.633c.329-.432.929-.597 1.402-.326z"
      ></path>
    </svg>
  );
}
